import React  from 'react';
import LloydCartFields from "./LloydCartFields";

export default function EnabledFormBottom({callbacks, lloydCart}) {
  return <section id="lloyd-item-section-bottom">
    <div id="lloyd-item-section-bottom-submit">
      <button type="button" className="btn" onClick={callbacks.submit}>Add to Cart</button>
    </div>
    <LloydCartFields lloydCart={lloydCart} />
  </section>
}

